//taken and modified from https://github.com/JamesEggers1/node-DateValidator/blob/master/src/date-validator.js
export function isSamordningsnummerValid(year: string, month: string, day: string): boolean {
  if (typeof year === 'undefined' || typeof month === 'undefined' || typeof day === 'undefined') {
    return false;
  }

  let yearParsed = Number(year);
  let monthParsed = Number(month);
  let dayParsed = Number(day);

  if (isNaN(monthParsed) || isNaN(dayParsed) || isNaN(yearParsed)) {
    return false;
  }

  monthParsed = parseInt(month, 10);
  dayParsed = parseInt(day, 10);
  yearParsed = parseInt(year, 10);

  if (monthParsed < 1 || dayParsed < 1 || yearParsed < 1) {
    return false;
  }

  return true;
}
